// import Attendance from "./Attendance";

export default {
  // component: Attendance,
  priority: 96,
  name: app.translate("نظر مدیر"),
  path: "monthly-manager-opinion",
  permissions: [
    "ManagerOpinion",
    "5e88132df0af145736a5e88132df0af145736a833fb6610eb6dbd7fcd2cc1b6c8fd51e8c542ef3d8a98833fb6610eb6dbd7fcd2cc1b6c8fd51e8c542ef3d8a98",
  ], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  // ,"ShiftDefinitionMenu", "PositionsMenu", "WritMenu", "PolicyDefinitionMenu", "SettingDefinitionMenu", "StackRulesMenu", "StackHistoryMenu"],
  component: load(() =>
    import(/* webpackChunkName: "Writs" */ "./ManagerOpinion")
  ),
  description: `نظر مدیر - نظر مدیر ماهیانه
با استفاده از این ماژول مدیران میتوانند نظر خود را بروی عملکرد ماهانه پرسنل اعمال نمایند و مقادیر محاسبه شده‌ی ماموریت و مرخصی و اضافه کاری و ... را با توجه به نیاز خود تغییر دهند. در این شرایط معمولا گزارش طبق نظر مدیر تهیه میگردد و برای محاسبات حقوق لحاظ می گردد`,
  icon: "av-timer",
  drawer: true,
};
